import UserApi from '../../api/user/user';
import Cookies from 'js-cookie';
import * as cookie from '../../config/cookies';

export default {
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        authentication(id) {
            this.isLoading = true;
            UserApi.getUserTokenById(id).then(token => {
                let tokenName = cookie.SUPERADMIN_TOKEN;
                if (!this.user.isSuperadmin) {
                    tokenName = this.user.type === 'admin' ? cookie.ADMIN_TOKEN : cookie.TEACHER_TOKEN;
                }
                if (!this.user.isSuperadmin && this.user.isManagerOrSupport) {
                    tokenName = this.user.type === 'manager' ? cookie.MANAGER_TOKEN : cookie.SUPPORT_TOKEN;
                }
                Cookies.set(tokenName, this.$store.state.auth.token);
                this.$store.commit('setUser', null);
                this.$store.commit('setCourse', null);
                this.$store.dispatch('setUserToken', token).finally(() => {
                    this.isLoading = false;
                });
            });
        },
    },
    watch: {
        isLoading(val) {
            this.$emit('loading', val);
        },
    },
};
